"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickDrawService = void 0;
const api_1 = require("./api");
const PATH_V1 = 'quickdraw/api/v1';
class QuickDrawService {
    static async getLatestQuickDrawWithWinnerResultByGame(id) {
        try {
            const response = await api_1.API.get({
                url: `${PATH_V1}/quickdraw/${id}/latest`
            });
            return response;
        }
        catch (error) {
            throw error;
        }
    }
    static async getQuickDrawJackpotResultsGrouped(gameId, page, size) {
        const url = `${PATH_V1}/jackpot-results-grouped?gameId.equals=${gameId}&page=${page || 0}&size=${size || 9999}&sort=drawDate,desc`;
        try {
            const response = await api_1.API.get({ url });
            return {
                content: response.content,
                page: {
                    first: response.first,
                    last: response.last,
                    totalElements: response.totalElements,
                    totalPages: response.totalPages,
                    number: response.number
                }
            };
        }
        catch (error) {
            throw error;
        }
    }
    static async getQuickDrawJackpotResultsFromDrawDate(gameId, drawDateFrom, page, size) {
        const url = `${PATH_V1}/jackpot-results?gameId.equals=${gameId}&drawDate.greaterThanOrEqual=${drawDateFrom}&page=${page || 0}&size=${size || 9999}&sort=externalDrawId,asc`;
        try {
            const response = await api_1.API.get({ url });
            return {
                content: response.content,
                page: {
                    first: response.first,
                    last: response.last,
                    totalElements: response.totalElements,
                    totalPages: response.totalPages,
                    number: response.number
                }
            };
        }
        catch (error) {
            throw error;
        }
    }
    static async getQuickDrawJackpotResultsByDrawId(gameId, drawId, page, size) {
        const url = `${PATH_V1}/jackpot-results?gameId.equals=${gameId}&externalDrawId.equals=${drawId}&page=${page || 0}&size=${size || 9999}&sort=externalDrawId,asc`;
        try {
            const response = await api_1.API.get({ url });
            return {
                content: response.content,
                page: {
                    first: response.first,
                    last: response.last,
                    totalElements: response.totalElements,
                    totalPages: response.totalPages,
                    number: response.number
                }
            };
        }
        catch (error) {
            throw error;
        }
    }
    static async getQuickDrawConfig(quickDrawId) {
        try {
            return await api_1.API.get({ url: `${PATH_V1}/quick-draw/${quickDrawId}/config` });
        }
        catch (error) {
            throw error;
        }
    }
}
exports.QuickDrawService = QuickDrawService;
//# sourceMappingURL=quick-draw-service.js.map